// Padlock BLE constants
export const PADLOCK_SERVICE_UUID = '0000fee7-0000-1000-8000-00805f9b34fb'
export const PADLOCK_WRITE_CHARACTERISTIC_UUID = '000036f5-0000-1000-8000-00805f9b34fb'
export const PADLOCK_READ_CHARACTERISTIC_UUID = '000036f6-0000-1000-8000-00805f9b34fb'
// Padlock BLE commands
export const PADLOCK_COMMAND_GET_TOKEN = '06010101000000000000000000000000'
// Padlock BLE key encryption constants
export const PADLOCK_ENCRYPTION_KEY_O35D22010147 = '886F825D2B30B9B0886F825D2B30B9B0'
export const PADLOCK_ENCRYPTION_KEY_O35D22010012 = '8E46D34E411678718E46D34E41167871'
